import React, { useEffect, useState } from 'react'
// import LoginFormUsername from './LoginFormUsername'
// import LoginFormPassword from './LoginFormPassword'
import MyButton from '../../UI/form/MyButton'
import { loginAPI } from '../../../api/user/userAPI'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { checkValid, setValueForm, updateValidate } from '../../../helpers/form/FormHelper'
import { setIsAuth, setUser } from '../../../store/userSlice'
import { formDataProductIsField, formDataProductRequiredField } from '../../../helpers/form/FormData'
import LoginFormUsername from './fields/LoginFormUsername'
import LoginFormPassword from './fields/LoginFormPassword'
import { responseError } from '../../../helpers/response/ResponseHelper'

const LoginForm = () => {

	const dispatch = useDispatch()
	const navigate = useNavigate()

	const [data, setData] = useState({
		email: '',
		password: ''
	}) // Дані з форми

	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [loading, setLoading] = useState(false)

	const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
	const [error, setError] = useState('')

	useEffect(() => {
			checkValid(valid, setIsValidForm)
		}, [valid])

	const login = (e) => {
		e.preventDefault()
		setError('')
		setLoading(true)
		loginAPI({
			email: data.email,
			password: data.password
		}).then(data => {
			localStorage.setItem('token', data.accessToken)
			dispatch(setIsAuth(true))
			dispatch(setUser(data.user))
			setLoading(false)
			navigate('/')
		}).catch(e => {
			setError(responseError(e))
			setLoading(false)
		})
	}

  return (
    <div className='loginPage__form-inputs'>
        {
            formDataProductIsField('email', 'login') ?
                <LoginFormUsername
                    required={formDataProductRequiredField('email', 'login')}
                    setValidate={e => updateValidate(setValid, 'email', e)}
                    setValueForm={e => setValueForm(setData, 'email', e)}
                    forciblyValue={data && data.email ? data.email : ''}
                />
            : ''
        }
		{
            formDataProductIsField('password', 'login') ?
                <LoginFormPassword
                    required={formDataProductRequiredField('password', 'login')}
                    setValidate={e => updateValidate(setValid, 'password', e)}
                    setValueForm={e => setValueForm(setData, 'password', e)}
                    forciblyValue={data && data.password ? data.password : ''}
                />
            : ''
        }

		{
			error ?
				<div className='error'>
					{error}
				</div>
			: ''
		}

		<MyButton
			onClick={login}
			disabled={!isValidForm ? true : false}
		>
			Увійти
		</MyButton>
    </div>
  )
}

export default LoginForm